var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.blacktype==2?'grayscale':''},[(!_vm.isPhone)?_c('div',[_c('Header')],1):_vm._e(),_c('router-view'),(!_vm.isPhone)?_c('record'):_vm._e(),(_vm.isPhone)?_c('record2'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }